

























import { Component, Vue } from "vue-property-decorator";
import PageNav from "./PageNav.vue";
import { namespace } from "vuex-class";

const AppStore = namespace("App");
const UserStore = namespace("User");

@Component({
  name: "UserNav",
  extends: PageNav
})
export default class UserNav extends Vue {
  @AppStore.State
  public reportYear!: number;

  @AppStore.State
  public canPublishReport!: boolean;

  @AppStore.State
  public canPublishPreliminaryReport!: boolean;

  @AppStore.State
  public canEditOrganizations!: boolean;

  @UserStore.Getter
  public isAdmin!: boolean;

  get showMenu() {
    return this.$route.meta?.showMenu !== false;
  }
}
